export default {
  strict: false,
  namespaced: true,

  state() {
    return {};
  },

  getters: {},

  mutations: {}
};
